import React from 'react';
import style from '../../styles/users.module.scss';
import { Button, Col, Row } from 'antd';
import Search from 'antd/es/transfer/search';
import FilterDropdown from '../filters/FilterDropdown';
import GenericTable from './GenericTable';
import Pagination from '../layout/Pagination';
import PropTypes from 'prop-types';

const TableSection = ({
  showFilter = false,
  createButtonDisplay,
  showCreateButton = true,
  onCreateClick,
  onSearch,
  filter,
  onFilterChange,
  columns,
  actions,
  data,
  emptyState,
  showPagination = false,
  currentPage,
  totalPages,
  onPageChange,
  searchPlaceholder = 'Pretraži',
  page,
  rowClassName,
  rowSelection,
}) => {
  return (
    <div>
      <Row className={style.users__header}>
        {/* <Row className={style.users__header__headerRow}>
          <Col className={style.users__header__search}>
            <Search
              placeholder={searchPlaceholder}
              className="search-input"
              allowClear
              enterButton
              onChange={(e) => onSearch(e.target.value)}
              width={showFilter ? 'auto' : '100%'}
            />
          </Col>
          {showFilter &&
            filter.sections.map((filterObj, index) => {
              let selectedLabel = filterObj[0]?.type;

              const filterSelected = filter.selected;

              if (filterSelected) {
                const label_for_get = filterObj[0]?.type || '';
                const foundSelected = filterSelected[label_for_get];

                if (foundSelected) {
                  selectedLabel =
                    foundSelected === 'active' ? 'Aktivan' : 'Neaktivan';
                }
              }

              return (
                <Col key={index}>
                  <FilterDropdown
                    sections={filterObj}
                    selectedFilter={filter.selected}
                    onFilterChange={onFilterChange}
                    buttonLabel={selectedLabel}
                  />
                </Col>
              );
            })}
        </Row> */}

        {/* {showCreateButton && createButtonDisplay && (
          <Col className={style.users__header__headerRow}>
            <Button
              className={`btn-primary ${style.users__header__addButton}`}
              type="primary"
              onClick={onCreateClick}
            >
              {createButtonDisplay}
            </Button>
          </Col>
        )} */}
      </Row>

      <div className={style.body}>
        <GenericTable
          data={data}
          columns={columns}
          actions={actions}
          emptyState={emptyState}
          rowClassName={rowClassName}
          rowSelection={rowSelection}
        />

        {showPagination && (
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={onPageChange}
          />
        )}
      </div>
    </div>
  );
};

TableSection.propTypes = {
  showFilter: PropTypes.bool,
  createButtonDisplay: PropTypes.string,
  onCreateClick: PropTypes.func,
  onSearch: PropTypes.func.isRequired,
  filter: PropTypes.shape({
    sections: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        options: PropTypes.arrayOf(
          PropTypes.shape({
            value: PropTypes.any,
            label: PropTypes.string,
          })
        ),
      })
    ),
    selected: PropTypes.object,
  }),
  onFilterChange: PropTypes.func,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      render: PropTypes.func,
      customCell: PropTypes.func,
    })
  ).isRequired,
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      icon: PropTypes.node,
      onClick: PropTypes.func,
      danger: PropTypes.bool,
      className: PropTypes.string,
    })
  ),
  data: PropTypes.array.isRequired,
  emptyState: PropTypes.shape({
    icon: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    actionButton: PropTypes.shape({
      label: PropTypes.string,
      onClick: PropTypes.func,
      type: PropTypes.string,
      style: PropTypes.object,
      className: PropTypes.string,
    }),
  }).isRequired,
  showPagination: PropTypes.bool,
  showCreateButton: PropTypes.bool,
  currentPage: PropTypes.number,
  totalPages: PropTypes.number,
  onPageChange: PropTypes.func,
  searchPlaceholder: PropTypes.string,
  rowSelection: PropTypes.shape({
    selectedRowKeys: PropTypes.array,
    onChange: PropTypes.func.isRequired,
    getCheckboxProps: PropTypes.func,
  }),
};

export default TableSection;
